// Time Picker — data-time-picker
(function () {
    const fmt2 = (n) => String(n).padStart(2, '0');

    function closeAll(except = null) {
        document.querySelectorAll('[data-time-picker].is-open').forEach(r => {
            if (r !== except) r.classList.remove('is-open');
            const trig = r.querySelector('.tp__input');
            trig?.setAttribute('aria-expanded', 'false');
        });
    }

    function buildMenu(root) {
        if (root.__built) return;
        root.__built = true;

        const menu = root.querySelector('.tp__menu') || (() => {
            const m = document.createElement('div'); m.className = 'tp__menu'; root.appendChild(m); return m;
        })();

        // Colonnes
        const colH = document.createElement('div'); colH.className = 'tp__col tp__col--h';
        const sep  = document.createElement('div'); sep.className  = 'tp__sep'; sep.textContent = ':';
        const colM = document.createElement('div'); colM.className = 'tp__col tp__col--m';

        menu.replaceChildren(colH, sep, colM);

        // Heures 00-23
        for (let h = 0; h < 24; h++) {
            const b = document.createElement('div');
            b.className = 'tp__opt'; b.dataset.h = String(h);
            b.textContent = fmt2(h);
            colH.appendChild(b);
        }

        // Minutes par step (défaut 15)
        const step = Math.max(1, parseInt(root.getAttribute('data-step') || '15', 10));
        for (let m = 0; m < 60; m += step) {
            const b = document.createElement('div');
            b.className = 'tp__opt'; b.dataset.m = String(m);
            b.textContent = fmt2(m);
            colM.appendChild(b);
        }

        // Click sur options
        menu.addEventListener('click', (e) => {
            const opt = e.target.closest('.tp__opt');
            if (!opt) return;

            e.stopPropagation();

            const input = root.querySelector('.tp__input');
            let h = 0, m = 0;

            // valeur actuelle
            const cur = (input?.value || '').split(':');
            if (cur.length === 2) {
                h = parseInt(cur[0], 10) || 0;
                m = parseInt(cur[1], 10) || 0;
            }

            if (opt.dataset.h != null) h = parseInt(opt.dataset.h, 10);
            if (opt.dataset.m != null) m = parseInt(opt.dataset.m, 10);

            // MAJ active
            menu.querySelectorAll('.tp__col--h .tp__opt').forEach(o => o.classList.toggle('is-active', parseInt(o.dataset.h,10) === h));
            menu.querySelectorAll('.tp__col--m .tp__opt').forEach(o => o.classList.toggle('is-active', parseInt(o.dataset.m,10) === m));

            const val = `${fmt2(h)}:${fmt2(m)}`;
            if (input) input.value = val;

            // Ferme après sélection complète (on ferme si on vient de cliquer minutes OU si pas de minutes à choisir)
            if (opt.dataset.m != null || step >= 60) {
                root.classList.remove('is-open');
                input?.setAttribute('aria-expanded', 'false');
            }
        });
    }

    function open(root) {
        closeAll(root);
        buildMenu(root);
        root.classList.add('is-open');
        const input = root.querySelector('.tp__input');
        input?.setAttribute('aria-expanded', 'true');

        // Met à jour l'état actif selon la valeur existante
        const menu = root.querySelector('.tp__menu');
        const inputVal = (input?.value || '');
        const [vh, vm] = inputVal.split(':');
        const h = parseInt(vh, 10);
        const m = parseInt(vm, 10);

        if (!isNaN(h)) {
            menu.querySelectorAll('.tp__col--h .tp__opt')
                .forEach(o => o.classList.toggle('is-active', parseInt(o.dataset.h,10) === h));
        }
        if (!isNaN(m)) {
            menu.querySelectorAll('.tp__col--m .tp__opt')
                .forEach(o => o.classList.toggle('is-active', parseInt(o.dataset.m,10) === m));
        }
    }

    function toggle(root) {
        if (root.classList.contains('is-open')) {
            closeAll();
        } else {
            open(root);
        }
    }

    // Ouverture/fermeture
    document.addEventListener('click', (e) => {
        const trig = e.target.closest('.tp__input');
        const root = e.target.closest('[data-time-picker]');
        const anyRoot = document.querySelector('[data-time-picker].is-open');

        // clic sur le trigger ?
        if (trig && root) {
            toggle(root);
            return;
        }

        // clic à l'intérieur du menu -> rien (géré plus haut)
        if (e.target.closest('.tp__menu')) return;

        // clic ailleurs -> fermer tout
        if (anyRoot && !root) closeAll();
    });

    // Escape ferme
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAll();
    });

    // Init ARIA
    document.querySelectorAll('[data-time-picker]').forEach(root => {
        const input = root.querySelector('.tp__input');
        if (input) {
            input.setAttribute('role', 'combobox');
            input.setAttribute('aria-haspopup', 'listbox');
            input.setAttribute('aria-expanded', 'false');
            input.readOnly = true; // évite clavier mobile & caret
        }
    });
})();
